import { Box, Button, Flex, Grid, Text } from "@mantine/core";
import { IconCircle, IconCircleFilled, IconPlus } from "@tabler/icons-react";

import { FindUserAddressesResponse } from "@/types/api/address";
import styles from "./styles.module.scss";

interface AddressesListProps {
  userAddresses: FindUserAddressesResponse[];
  selectedAddress: FindUserAddressesResponse | null;
  setSelectedAddress: (addressId: FindUserAddressesResponse) => void;
  handleOpenCreateAddressModal: () => void;
}

export function AddressesList({
  selectedAddress,
  setSelectedAddress,
  userAddresses,
  handleOpenCreateAddressModal,
}: AddressesListProps) {
  return (
    <Grid>
      <Grid.Col span={{ md: 12 }} mb={10}>
        <Button
          className={styles.createAddressButton}
          leftSection={<IconPlus />}
          onClick={handleOpenCreateAddressModal}
        >
          Criar Novo Endereço
        </Button>
      </Grid.Col>

      {userAddresses.map((address, i) => (
        <Grid.Col span={{ md: 12 }} key={i}>
          <Box
            className={`${styles.selectAddressButton} ${selectedAddress?.id === address.id ? styles.selectedAddress : ""}`}
            onClick={() => setSelectedAddress(address)}
          >
            {selectedAddress?.id === address.id ? (
              <IconCircleFilled />
            ) : (
              <IconCircle />
            )}

            <Flex className={styles.addressInfoContainer}>
              <Text>
                {address.street}, {address.number} - {address.complement}
              </Text>
              <Text>
                {address.neighborhood}, {address.city} - {address.state}
              </Text>
            </Flex>
          </Box>
        </Grid.Col>
      ))}
    </Grid>
  );
}
